<script>
    import { navigate } from 'svelte-routing'
    import date from 'date-and-time'
    import { Functions } from '../../config/firebase'
    import { currentUser } from '../../stores/current_user'

    import Form from './form.svelte'
    import { Spinner } from 'sveltestrap'

    let saving = false

    const agent = {
        name: '',
        email: '',
        password: '',
        active: true,
        role: 'user',
        phoneNumber: '',
        address: {
            address1: '',
            address2: '',
            postalCode: '',
            city: '',
            country: '',
            state: null
        }
    }

    function saveHandler(event) {
        saving = true
        let agent = event.detail
        agent.role = 'user'
        agent.active = true
        const createAgent = Functions.httpsCallable('createAgent')

        createAgent(agent)
            .then((reply) => {
                saving = false
                navigate('/agents')
            }, err => {
                alert('Could not create new agent.')
                console.log('Save Agent:', err)
                saving = false
            })

    }
</script>

{#if !saving}
<Form pageTitle="Create new agent" {agent} on:submit={saveHandler} />
{:else}
<Spinner size="lg" color="dark" type="grow" />
{/if}